import { CartState } from '@src/infrastructure/storage/cartStore';
import { Serializer } from '../serializer';
import { Storage } from './storage';


export class CookieStorage implements Storage {
    private readonly key = 'cart';
    private readonly serializer: Serializer;

    constructor() {
        this.serializer = new Serializer();
    }

    set = async (cart: CartState) => {
        // expire the old cookie first then set the new one
        const currentYear = new Date().getFullYear();
        const yearPlus10 = currentYear + 10;
        const yearMinus10 = currentYear - 10;
        const cartSerialized = this.serializer.serialize(cart);
        document.cookie = `${this.key}=${cartSerialized}; expires=Mon, 20 Sep ${yearMinus10} 00:00:00 UTC; path=/`
        document.cookie = `${this.key}=${cartSerialized}; expires=Tue, 31 Dec ${yearPlus10} 00:00:00 UTC; path=/`
    }

    get = async (): Promise<CartState> => {
        const cartSerialized = this.getFromStr(this.key, decodeURIComponent(document.cookie));
        return this.serializer.deserialize(cartSerialized);
    }

    private getFromStr(name, text) {
        if (typeof text !== "string") {
            return;
        }
        var nameEQ = name + "=",
            ca = text.split(/[;&]/),
            i, c;
        for (i = 0; i < ca.length; i++) {
            c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
    }
}